import { keyBy } from 'lodash-es'
import { treq } from '#app/lib/treq'
import { serializeItem, setItemUserData, type SerializedItemWithUserData } from '#inventory/lib/items'
import type { EntityUri } from '#server/types/entity'
import { mainUser } from '#user/lib/main_user'
import { serializeUser } from '#users/lib/users'

export async function getItemsData (editionsUris: EntityUri[]) {
  const { items, users } = await treq('items', 'get', 'by-entities', { uris: editionsUris })
  const serializedUsers = users.map(serializeUser)
  const serializedItems = items.map(serializeItem)
  const usersByIds = keyBy(serializedUsers, '_id')
  return serializedItems.map(item => {
    return setItemUserData(item, usersByIds[item.owner])
  }) as SerializedItemWithUserData[]
}

export function sortItemsByCategoryAndDistance (items: SerializedItemWithUserData[]) {
  const itemsByCategories = {
    personal: [],
    network: [],
    public: [],
    nearbyPublic: [],
    otherPublic: [],
  }
  items.forEach(item => {
    const category = getItemCategory(item)
    itemsByCategories[category] = [ ...itemsByCategories[category], item ]
  })
  Object.keys(itemsByCategories).forEach(category => {
    itemsByCategories[category] = itemsByCategories[category].sort(byDistance)
  })
  return itemsByCategories
}

function getItemCategory (item: SerializedItemWithUserData) {
  let category = item.category
  if (category === 'public') category = isNearby(item.distanceFromMainUser) ? 'nearbyPublic' : 'otherPublic'
  if (item.owner === mainUser?._id) category = 'personal'
  return category
}

const byDistance = (distanceA: number, distanceB: number) => distanceA - distanceB
const nearbyKmPerimeter = 50
export const isNearby = (distance: number) => distance != null && distance < nearbyKmPerimeter

export const categoriesHeaders = {
  personal: {
    label: 'in your inventory',
    customIcon: 'user',
    backgroundColor: '#eeeeee',
  },
  network: {
    label: "in your friends' and groups' inventories",
    customIcon: 'users',
    backgroundColor: '#f4f4f4',
  },
  nearbyPublic: {
    label: 'nearby',
    customIcon: 'dot-circle-o',
    backgroundColor: '#f8f8f8',
  },
  otherPublic: {
    label: 'elsewhere',
    customIcon: 'globe',
    backgroundColor: '#fcfcfc',
  },
}
